import { Redirect, Route, Switch } from "react-router-dom";

import { RootPaths } from "../../App/paths";
import { NCOrientationPage } from "../Documents/NorthCarolinaOrientation/Page";
import { EarlyAccessPage } from "../EarlyAccessFacilities/EarlyAccessPage";
import { FindVisitsPage } from "../InHome/Page";
import { ShiftBlocksPage } from "../Shift/Block/Page";
import { OrientationShiftBlocksPage } from "../Shift/OrientationBlock/Page";
import { TravelBlocksPage } from "../Shift/TravelBlock/Page";
import { CommonModalRoutes } from "./CommonModalRoutes";
import { FavoriteWorkplacesModalRoutes } from "./FavoriteWorkplacesModalRoutes";
import { getBaseModalsNavigationPath } from "./getBaseModalsNavigationPath";
import { InHomeModalRoutes } from "./InHomeModalRoutes";
import { ShiftDiscoveryListViewPage } from "./ListView/Page";
import { ShiftDiscoveryMapViewPage } from "./MapView/Page";
import {
  SHIFT_DISCOVERY_BLOCKS_PATH,
  SHIFT_DISCOVERY_EARLY_ACCESS_PATH,
  SHIFT_DISCOVERY_HOME_HEALTH_PATH,
  SHIFT_DISCOVERY_IN_HOME_PATH,
  SHIFT_DISCOVERY_LIST_PATH,
  SHIFT_DISCOVERY_MAP_PATH,
  SHIFT_DISCOVERY_NC_ORIENTATION_PATH,
  SHIFT_DISCOVERY_ORIENTATION_BLOCKS_PATH,
  SHIFT_DISCOVERY_PRIORITY_PATH,
  SHIFT_DISCOVERY_TRAVEL_BLOCKS_PATH,
  SHIFT_DISCOVERY_URGENT_PATH,
} from "./paths";
import { ShiftDiscoveryPriorityShiftsPage } from "./PriorityShifts/Page";
import { ShiftModalRoutes } from "./ShiftModalRoutes";
import { ShiftDiscoveryUrgentShiftsPage } from "./UrgentShifts/Page";
import { InHomeVisitModalsDataProvider } from "./useInHomeVisitModalsDataContext";
import { useInvalidateShiftsOnDeeplink } from "./useInvalidateShiftsOnDeeplink";
import { useShiftDiscoverySearchMode } from "./useShiftDiscoverySearchMode";
import { ShiftModalsDataProvider } from "./useShiftModalsDataContext";
import { WorkplaceModalsDataProvider } from "./useWorkplaceModalsDataContext";
import { WorkplaceModalRoutes } from "./WorkplaceModalRoutes";

export function ShiftDiscoveryRouter() {
  useInvalidateShiftsOnDeeplink();

  const searchMode = useShiftDiscoverySearchMode();

  const baseModalsNavigationPath = getBaseModalsNavigationPath(searchMode);

  return (
    <WorkplaceModalsDataProvider baseNavigationPath={baseModalsNavigationPath}>
      <ShiftModalsDataProvider
        baseNavigationPath={baseModalsNavigationPath}
        searchMode={searchMode}
      >
        <InHomeVisitModalsDataProvider
          baseNavigationPath={`${baseModalsNavigationPath}/${SHIFT_DISCOVERY_IN_HOME_PATH}`}
        >
          <FavoriteWorkplacesModalRoutes baseNavigationPath={baseModalsNavigationPath} />
          <WorkplaceModalRoutes />
          <ShiftModalRoutes />
          <InHomeModalRoutes />
          <CommonModalRoutes baseNavigationPath={baseModalsNavigationPath} />

          <Switch>
            <Route
              path={`${baseModalsNavigationPath}/${SHIFT_DISCOVERY_URGENT_PATH}`}
              component={ShiftDiscoveryUrgentShiftsPage}
            />
            <Route
              path={`${baseModalsNavigationPath}/${SHIFT_DISCOVERY_HOME_HEALTH_PATH}`}
              component={FindVisitsPage}
            />
            <Route
              path={`${baseModalsNavigationPath}/${SHIFT_DISCOVERY_IN_HOME_PATH}`}
              component={FindVisitsPage}
            />
            <Route
              path={`${baseModalsNavigationPath}/${SHIFT_DISCOVERY_PRIORITY_PATH}`}
              component={ShiftDiscoveryPriorityShiftsPage}
            />
            <Route
              path={`${baseModalsNavigationPath}/${SHIFT_DISCOVERY_EARLY_ACCESS_PATH}`}
              component={EarlyAccessPage}
            />
            <Route
              path={`${baseModalsNavigationPath}/${SHIFT_DISCOVERY_NC_ORIENTATION_PATH}`}
              component={NCOrientationPage}
            />
            <Route
              path={`${baseModalsNavigationPath}/${SHIFT_DISCOVERY_ORIENTATION_BLOCKS_PATH}`}
              component={OrientationShiftBlocksPage}
            />
            <Route
              path={`${baseModalsNavigationPath}/${SHIFT_DISCOVERY_BLOCKS_PATH}`}
              component={ShiftBlocksPage}
            />
            <Route
              path={`${baseModalsNavigationPath}/${SHIFT_DISCOVERY_TRAVEL_BLOCKS_PATH}`}
              component={TravelBlocksPage}
            />
            <Route
              path={`${RootPaths.APP_V2_HOME}/${SHIFT_DISCOVERY_LIST_PATH}`}
              component={ShiftDiscoveryListViewPage}
            />
            <Route
              path={`${RootPaths.APP_V2_HOME}/${SHIFT_DISCOVERY_MAP_PATH}`}
              component={ShiftDiscoveryMapViewPage}
            />
            <Route
              render={() => (
                <Redirect to={`${RootPaths.APP_V2_HOME}/${SHIFT_DISCOVERY_LIST_PATH}`} />
              )}
            />
          </Switch>
        </InHomeVisitModalsDataProvider>
      </ShiftModalsDataProvider>
    </WorkplaceModalsDataProvider>
  );
}
